<button class="accent transparent" mat-flat-button appStopPropagation (click)="handleClick()">
  {{ 'button.viewContent' | translate }}
</button>
